;(function () {
  'use strict'
  angular
    .module('contrast.loading')
    .directive('loadingSpinner', function loadingSpinner() {
      return {
        replace: true,
        restrict: 'EA',
        templateUrl: 'views/common/loading_spinner.html'
      }
    })
})()
